import Sp360AnalyticsService from '@/services/Sp360AnalyticsService';

export const sp360Analytics = {
  namespaced: true,
  actions: {

    dadosDeAcessosNoIntervalo({dispatch}, {dataInicio, dataFim, intervalo}) {
      return Sp360AnalyticsService.dadosDeAcessosNoIntervalo({
          dataInicio,
          dataFim,
          intervalo
        })
        .then(
          response => {
            return response;
          },
          error => {
            console.error(error);
          }
        );
    },
    contabilizarAcesso ({dispatch}, payload) {
        return Sp360AnalyticsService.contabilizarAcesso(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                }
            );
    }
  },
  state: {},
  mutations: {},
};
